import PropTypes from 'prop-types';
import React from 'react';
import { InputDiv, InputLabelDiv, InputNumberField } from './InputStyles';

const NumberInput = ({
  input,
  meta,
  size,
  label,
  first,
  max,
  min,
  step,
  placeholder,
  disabled
}) => {
  const { invalid, submitFailed } = meta;
  const showError = invalid && submitFailed;

  return (
    <InputDiv first={first}>
      {label && <InputLabelDiv>{label}</InputLabelDiv>}
      <InputNumberField
        disabled={disabled}
        size={size}
        max={max}
        type="number"
        min={min}
        step={step}
        placeholder={placeholder}
        value={input.value}
        onChange={input.onChange}
        error={showError ? 1 : 0}
      />
    </InputDiv>
  );
};

NumberInput.propTypes = {
  label: PropTypes.string,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired
};

export default NumberInput;
